import React from 'react';
import MissionParticipantsList from '@/components/admin/MissionParticipantsList';
import { useParams } from 'react-router-dom';

const AdminMissionParticipantsPage = () => {
  const { missionId } = useParams();

  return <MissionParticipantsList />;
};

export default AdminMissionParticipantsPage;
